// src/components/cctv/CameraView.js
import React, { useEffect, useRef } from "react";
import { ChevronLeft } from "lucide-react";

const CameraView = ({
    onBack,
    streamUrl,
    useLegacyPlayer = false,
    usePostEmbed = false,
    embedUrl,
    embedParams,
    hybridAuth = { enabled: false },
}) => {
    console.log("st", streamUrl)

    const isM3U8 = useLegacyPlayer && streamUrl?.includes(".m3u8");

    const formRef = useRef(null);
    const iframeRef = useRef(null);

    // Auto-submit hidden form whenever we have valid embed params
    useEffect(() => {
        if (useLegacyPlayer) return;
        if (
            !usePostEmbed ||
            !embedUrl ||
            !embedParams?.id1 ||
            !embedParams?.id2 ||
            !embedParams?.hash ||
            (hybridAuth?.enabled && hybridAuth?.hasError !== true)
        ) {
            return;
        }

        try {
            if (formRef.current) {
                formRef.current.submit();
            }
        } catch (e) {
            console.error("[CameraView] Failed to submit CCTV embed form", e);
        }
    }, [
        usePostEmbed,
        embedUrl,
        embedParams?.id1,
        embedParams?.id2,
        embedParams?.hash,
        hybridAuth?.enabled,
        hybridAuth?.hasError,
    ]);

    return (
        <div className="fixed inset-0 bg-black flex flex-col z-50">

            {/* HEADER */}
            <div className="flex items-center justify-between p-4 bg-gray-900">
                <button onClick={onBack} className="text-white">
                    <ChevronLeft className="w-6 h-6" />
                </button>
                <h2 className="text-white font-semibold cursor-pointer" onClick={onBack}>Live Camera</h2>
                <div className="w-6"></div>
            </div>

            {/* PLAYER */}
            <div className="flex-1 flex items-center justify-center bg-black">
                {isM3U8 ? (
                    <video
                        src={streamUrl}
                        autoPlay
                        controls
                        playsInline
                        className="w-full h-full object-contain"
                    />
                ) : hybridAuth?.enabled && hybridAuth?.src ? (
                    <iframe
                        title="cctv-hybrid"
                        src={hybridAuth.src}
                        className="w-full h-full"
                        allowFullScreen
                        frameBorder="0"
                    />
                ) : useLegacyPlayer ? (
                    <iframe
                        title="cctv"
                        src={streamUrl}
                        className="w-full h-full"
                        allowFullScreen
                        frameBorder="0"
                    />
                ) : hybridAuth?.enabled && hybridAuth?.hasError !== true && !hybridAuth?.src ? (
                    <div className="text-white">Loading camera...</div>
                ) : usePostEmbed && embedUrl && embedParams?.id1 && embedParams?.id2 && embedParams?.hash ? (
                    <div className="w-full h-full">
                        {/* The iframe (no src — loaded via form POST) */}
                        <iframe
                            name="center-embed"
                            id="center-embed"
                            ref={iframeRef}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            allow="fullscreen"
                            className="w-full h-full"
                            title="cctv-embed"
                        />

                        {/* Hidden form that submits into the iframe */}
                        <form
                            ref={formRef}
                            method="POST"
                            action={embedUrl}
                            target="center-embed"
                            style={{ display: "none" }}
                        >
                            <input type="hidden" name="id1" value={embedParams.id1} />
                            <input type="hidden" name="id2" value={embedParams.id2} />
                            <input type="hidden" name="hash" value={embedParams.hash} />
                        </form>
                    </div>
                ) : (
                    <iframe
                        title="cctv"
                        src={streamUrl}
                        className="w-full h-full"
                        allowFullScreen
                        frameBorder="0"
                    />
                )}
            </div>

        </div>
    );
};

export default CameraView;
